// en.js
export default {
  appText: 'CommsEase IM H5',
  messageText: 'Chats',
  contactText: 'Contacts',
  mineText: 'Me',
  logoutText: 'Log out',
  commsEaseText: 'About',
  logoutConfirmText: 'Are you sure you want to log out?',
  avatarText: 'Avatar',
  accountText: 'Account',
  name: 'Nickname',
  genderText: 'Gender',
  remarkText: 'Alias',
  mobile: 'Phone',
  email: 'Email',
  sign: "What's Up",
  man: 'Male',
  woman: 'Female',
  unknow: 'Unknown',
  birthText: 'Birthday',
  FriendPageText: 'Friend Card',
  startConversationText: 'Start Chat',
  addText: 'Add',
  applyFriendSuccessText: 'Request Sent',
  applyFriendFailText: 'Request Failed',
  addFriendText: 'Add Friend',
  addFriendFailText: 'Add Friend Failed',
  deleteFriendText: 'Delete Friend',
  deleteFriendConfirmText: 'Are you sure you want to delete this friend?',
  deleteFriendSuccessText: 'Delete Friend Success',
  deleteFriendFailText: 'Delete Friend Failed',
  setBlackFailText: 'Add to blacklist failed',
  removeBlackFailText: 'Remove from blacklist failed',
  removeBlackSuccessText: 'Remove from blacklist success',
  addPermissionText: 'Please add relevant permissions in the system settings page',
  FailAvatarText: 'Avatar upload failed',
  chooseDefaultImage: 'Choose default image',
  chatButtonText: 'Go to Chat',
  gotoChatFailText: 'Go to chat failed',
  chatWithFriendText: 'Chat',
  okText: 'Done',
  yesText: 'Yes',
  updateText: 'Update',
  cancelText: 'Cancel',
  friendSelectText: 'Select Friend',
  telErrorText: 'Invalid phone number format',
  emailErrorText: 'Invalid email format',
  createButtonText: 'Create',
  createP2PText: 'Start Chat',
  createTeamText: 'Create Group',
  addTeamMemberText: 'Add Group Member',
  addTeamMemberFailText: 'Add Group Member Failed',
  teamTitlePlaceholder: 'Enter Group Name',
  maxSelectedText: 'You can only select up to 200 friends',
  createTeamSuccessText: 'Create Group Success',
  createTeamFailedText: 'Create Group Failed',
  PersonalPageText: 'My Profile',
  deleteSessionText: 'Delete',
  sessionMuteText: 'Notification',
  sessionMuteFailText: 'Mute Notifications Failed',
  sessionUnMuteFailText: 'Unmute Notifications Failed',
  stickTopText: 'Sticky on Top',
  deleteStickTopText: 'Unpin Chat',
  addStickTopText: 'Pin',
  deleteSessionFailText: 'Delete Conversation Failed',
  deleteStickTopFailText: 'Unpin Chat Failed',
  addStickTopFailText: 'Pin Message Failed',
  teamMemberText: 'Group Members',
  teamIdText: 'Group ID',
  saveText: 'Save',
  setText: 'Settings',
  failText: 'Failed',
  saveSuccessText: 'Save Success',
  saveFailedText: 'Save Failed',
  searchTeamPlaceholder: 'Enter Group Name',
  teamTitle: 'Group Name',
  teamInfoText: 'Group Infomation',
  teamIntro: 'Introduction',
  teamAvatar: 'Profile Picture',
  networkError: 'Current network error',
  searchFailText: 'Search Failed',
  offlineText: 'Network is unavailable, please check network settings.',
  connectingText: 'The current IM connection has been disconnected and is reconnecting…',
  teamMenuText: 'My Groups',
  teamChooseText: 'MY GROUPS',
  recentSessionText: 'LATEST CHAT',
  myFriendText: 'MY FRIENDS',
  recentForwardText: 'Recent Forwards',
  chooseText: 'Choose',
  friendSelect: 'Please select a contact',
  getHistoryMsgFailedText: 'Failed to get message history',
  getMergedForwardFailedText: 'Failed to get information',
  deleteText: 'Delete',
  multiDeleteLimitText: 'Batch delete is limited to 50 messages',
  recallText: 'Recall',
  copyText: 'Copy',
  forwardText: 'Forward',
  multiSelectText: 'Multi-select',
  oneByOneForwardText: 'One by one forward',
  oneByOneForwardLimitText: 'One by one forward supports up to 10 messages',
  mergeForwardText: 'Merged forward',
  mergeForwardLimitText: 'Merged forward supports up to 100 messages',
  forwardMultiSelectLimitText: 'You can only select up to 9 conversations',
  forwardExceptionTitle: 'Exception details',
  forwardExceptionContent: "Some messages can't be forwarded. Remove them before retry",
  noForwardableMsgText: 'No forwardable messages',
  pleaseSelectMsgText: 'Please select messages',
  forwardComment: 'forward comment',
  replyText: 'Reply',
  replyNotFindText: 'Message has recalled or deleted',
  forwardToTeamText: 'Forward to Group',
  forwardToFriendText: 'Forward to Contact',
  sessionRecordText: 'Conversation Record',
  chatInputPlaceHolder: 'What would you like to say?',
  enableV2CloudConversationText: 'Enable V2 Cloud Conversation',
  SwitchToEnglishText: 'Switch to English',
  pinText: 'Pin',
  pinFailedText: 'Pin Failed',
  unpinText: 'Unpin',
  unpinSuccessText: 'Unpin',
  unpinFailedText: 'Unpin Failed',
  noPinListText: 'No pinned messages',
  collectionText: 'Favorite',
  deleteCollectionText: 'Delete collection',
  addCollectionSuccessText: 'Added',
  addCollectionFailedText: 'Add collection Failed',
  collectionLimitText: 'Collection limit reached',
  deleteCollectionConfirmText: 'Are you sure you want to delete this favorite?',
  deleteCollectionFailedText: 'Delete collection Failed',
  noCollectionsText: 'No collection',
  teamBannedText: 'Group Mute',
  nickInTeam: 'My Alias in Group',
  you: 'You',
  pinThisText: 'Pinned by',
  delete: 'Confirm message deletion',
  recall: 'Recalled a message',
  recall2: 'This message has been recalled',
  recall3: 'Recall this message',
  recallMsgFailText: 'Recall Message Failed',
  reeditText: 'Edit',
  loadingMoreText: 'Loading…',
  noMoreText: 'No more',
  deleteMsgSuccessText: 'Delete Success',
  deleteMsgFailText: 'Delete Failed',
  conversationEmptyText: 'No conversation',
  teamOwner: 'Group Owner',
  teamManager: 'Group Manager',
  teamEmptyText: 'No Group Chats',
  blacklistEmptyText: 'No blocked members',
  blacklistSubTitle: 'You will not get messages from anyone on the list.    ',
  validEmptyText: 'Verifications Empty',
  dismissTeamText: 'Dismiss Group',
  dismissTeamConfirmText: 'Are you sure you want to dismiss this group?',
  leaveTeamTitle: 'Leave Group',
  leaveTeamConfirmText: 'Are you sure you want to leave this group?',
  leaveTeamSuccessText: 'You have left this group',
  leaveTeamFailedText: 'Failed to leave this group',
  dismissTeamSuccessText: 'Dismiss Group Success',
  dismissTeamFailedText: 'Dismiss Group Failed',
  updateTeamSuccessText: 'Update Success',
  updateTeamFailedText: 'Update Failed',
  teamTitleConfirmText: 'Group name cannot be empty',
  teamIntroConfirmText: 'Group introduction cannot be empty',
  aliasConfirmText: 'Alias cannot be empty',
  sendImageFailedText: 'Failed to send Image',
  sendVideoFailedText: 'Failed to send Video',
  sendAudioFailedText: 'Failed to send Audio',
  sendFileFailedText: 'Failed to send File',
  fileSizeLimitText: 'The current file exceeds the 200 MB sending limit. Please choose another file.',
  sendMsgFailedText: 'Failed to send Message',
  tipText: 'tip',
  selectImageText: 'please select image',
  friendEditPlaceholder: "Please enter the friend's nickname",
  uikitVersion: 'Version',
  IMVersion: 'NIM Version',
  productInfoText: 'Product Info',

  weekText: 'Weeks ago',
  dayText: 'Days ago',
  hourText: 'Hours ago',
  minuteText: 'Minutes ago',
  nowText: 'Just now',
  sendText: 'Send',
  selectedText: 'Selected',
  sendToText: 'Send to',
  textMsgText: 'Text Message',
  audioMsgText: 'Audio Message',
  videoMsgText: 'Video Message',
  fileMsgText: 'File Message',
  callMsgText: 'Call Message',
  geoMsgText: 'Location Message',
  imgMsgText: 'Image Message',
  notiMsgText: 'Notification Message',
  robotMsgText: 'Robot Message',
  tipMsgText: 'Tip Message',
  customMsgText: 'Custom Message',
  chatHistoryText: 'Chat history',
  messageOfText: 'Messages',
  unknowMsgText: 'Unknown Message',
  noFriendText: 'No Friends',
  searchNoResultPrefix: 'No results found for "',
  searchNoResultSuffix: '"',
  onDismissTeamText: 'This group has been dismissed',
  onTeamKickedText: 'You have been removed from the group chat',
  chatTeamInvalidText: 'The group no longer exists',
  onRemoveTeamText: 'You have left the group',
  selectSessionFailText: 'Failed to select conversation',
  noExistUser: 'This user does not exist',
  enterAccount: 'Enter account',
  validMsgText: 'Verifications',
  friendTabText: 'FRIEND',
  teamTabText: 'GROUP',
  blacklistText: 'Blocklist',
  applyTeamText: 'Apply to Join Group',
  expiredText: 'Expired',
  acceptResultText: 'Accepted',
  rejectResultText: 'Rejected',
  rejectTeamInviteText: 'Rejected group invitation',
  beRejectResultText: 'Rejected friend request',
  passResultText: 'Accepted friend request',
  acceptedText: 'This request has been accepted',
  acceptFailedText: 'Failed to accept this request',
  rejectedText: 'This request has been rejected',
  rejectFailedText: 'Failed to reject this request',
  passFriendAskText: "I have accepted your friend request, let's start chatting!",
  applyFriendText: 'Add you as a friend',
  rejectText: 'Decline',
  acceptText: 'Accept',
  clearText: 'Clear',
  clearFriendConfirmTitle: 'Clear Friend Application',
  clearFriendConfirmContent: 'Are you sure to clear Friend Application?',
  clearTeamConfirmTitle: 'Clear Group Application',
  clearTeamConfirmContent: 'Are you sure to clear Group Application?',
  inviteTeamText: 'Invite to Group',
  addBlacklist: 'Block',
  removeBlacklist: 'Release',
  forwardSuccessText: 'Forward Success',
  forwardFailText: 'Forward Failed',
  getMessageFailed: 'Fail to get message',
  getForwardMessageFailed: 'Fail to get forward message',
  getHistoryFailedText: 'Fail to get history message',
  sendFailWithInBlackText: 'The other party has blocked you, message sending failed',
  sendFailWithDeleteText: 'The relationship between both parties has been terminated, please reapply for contact',
  friendVerificationText: 'Friend Verification',
  teamAll: 'all',
  chooseMentionText: 'Choose Mention',
  someoneText: 'someone',
  meText: 'mention',
  teamMutePlaceholder: 'The current group owner has set the group to mute',
  viewMoreText: 'View More',
  resendMsgFailText: 'Resend Failed',
  audioBtnText: 'Press and hold to speak',
  audioRemindText: 'Release to send',
  audioErrorText: 'Recording failed',
  videoPlayText: 'Video Play',
  voiceCallText: 'Voice Call',
  videoCallText: 'Video Call',
  callDurationText: 'call duration',
  callCancelText: 'canceled',
  callRejectedText: 'rejected',
  callTimeoutText: 'Missed call',
  callBusyText: 'busy line',
  callFailedText: 'call failed',
  wxAppFileCopyText: 'Please paste the URL in the mobile browser.',
  shootText: 'shoot',
  albumText: 'album',
  msgReadPageTitleText: 'Message Reading Status',
  readText: 'Read',
  unreadText: 'Unread',
  fileText: 'file',
  allUnReadText: 'All Unread',
  msgRecallTimeErrorText: 'Message recall time exceeded',
  allReadText: 'All Read',
  searchText: 'Enter and search...',
  searchTitleText: 'Search',
  friendText: 'Friend',
  teamText: 'Group',
  searchResultNullText: 'User does not exist',
  conversationSendFailText: '[Send Failed]',
  conversationNotificationText: '[Notification]',
  fileMsgTitleText: '[File Message]',
  collectionFromText: 'Collection from',
  copySuccessText: 'Copy Success',
  copyFailText: 'Copy failed',
  openUrlText: 'Copied. Open in browser.',
  teamManagerText: 'Group Manager',
  teamManagerSettingText: 'Group Manager Setting',
  updateTeamInfoText: 'Who is allowed to edit group details',
  teamOwnerAndManagerText: 'GroupOwnerAndManager',
  updateTeamInviteText: 'Who is allowed to invite group members',
  updateTeamAtText: 'Who is allowed to @',
  addMemberText: 'Add Member',
  removeText: 'remove',

  securityTipText: 'For test only. Beware of money transfer, lottery winnings strange call scams.',
  reportText: 'Report',
  timeFormatSameYear: 'MMM/DD HH:mm',
  timeFormatDiffYear: 'MM/DD/YY HH:mm',
  sendToFriend: 'send to friend',
  sendToTeam: 'send to group',

  // emoji 不能随便填，要用固定 key
  Laugh: '[Laugh]',
  Happy: '[Happy]',
  Sexy: '[Sexy]',
  Cool: '[Cool]',
  Mischievous: '[Mischievous]',
  Kiss: '[Kiss]',
  Spit: '[Spit]',
  Squint: '[Squint]',
  Cute: '[Cute]',
  Grimace: '[Grimace]',
  Snicker: '[Snicker]',
  Joy: '[Joy]',
  Ecstasy: '[Ecstasy]',
  Surprise: '[Surprise]',
  Tears: '[Tears]',
  Sweat: '[Sweat]',
  Angle: '[Angle]',
  Funny: '[Funny]',
  Awkward: '[Awkward]',
  Thrill: '[Thrill]',
  Cry: '[Cry]',
  Fretting: '[Fretting]',
  Terrorist: '[Terrorist]',
  Halo: '[Halo]',
  Shame: '[Shame]',
  Sleep: '[Sleep]',
  Tired: '[Tired]',
  Mask: '[Mask]',
  ok: '[ok]',
  AllRight: '[All right]',
  Despise: '[Despise]',
  Uncomfortable: '[Uncomfortable]',
  Disdain: '[Disdain]',
  ill: '[ill]',
  Mad: '[Mad]',
  Ghost: '[Ghost]',
  Angry: '[Angry]',
  Unhappy: '[Unhappy]',
  Frown: '[Frown]',
  Broken: '[Broken]',
  Beckoning: '[Beckoning]',
  Ok: '[Ok]',
  Low: '[Low]',
  Nice: '[Nice]',
  Applause: '[Applause]',
  GoodJob: '[Good job]',
  Hit: '[Hit]',
  Please: '[Please]',
  Bye: '[Bye]',
  First: '[First]',
  Fist: '[Fist]',
  GiveMeFive: '[Give me five]',
  Knife: '[Knife]',
  Hi: '[Hi]',
  No: '[No]',
  Hold: '[Hold]',
  Think: '[Think]',
  Pig: '[Pig]',
  NoListen: '[No listen]',
  NoLook: '[No look]',
  NoWords: '[No words]',
  Monkey: '[Monkey]',
  Bomb: '[Bomb]',
  Cloud: '[Cloud]',
  Rocket: '[Rocket]',
  Ambulance: '[Ambulance]',
  Poop: '[Poop]',
  // 错误码及提示内容
  // 通用错误码
  190001: 'internal error',
  190002: 'illegal state',
  191001: 'misuse',
  191002: 'cancelled',
  191003: 'callback failed',
  191004: 'invalid parameter',
  191005: 'timeout',
  191006: 'resource not exist',
  191007: 'resource already exist',
  // 连接相关
  192001: 'connect failed',
  192002: 'connect timeout',
  192003: 'disconnected',
  192004: 'protocol timeout',
  192005: 'protocol send failed',
  192006: 'request failed',
  // 消息相关
  107319: 'Number of pin reaches the limit.',
  107320: 'PIN not exist',
  107322: 'PIN already exist',
  107327: 'PIN function disabled',
  189301: 'collection limit exceeded',
  189302: 'collection not exist',
  189449: 'collection concurrent operation failed',
  // 群相关
  109432: 'no permission',
  // 用户在线状态
  userOnlineText: 'Online',
  userOfflineText: 'Offline',
  // 语音转文字
  voiceToTextText: 'To Text',
  voiceToTextFailText: 'To text failed'
}
